import { EventPublication } from '@news-mono/web-common'
import { EventPostV4DTO } from '@west-australian-newspapers/publication-types'
import React from 'react'
import { Helmet } from 'react-helmet'
import { useLiveBlogPostingSchema } from '../helpers'

export const LiveEventStructuredData: React.FC<{
    publication: EventPublication
    activePosts: EventPostV4DTO[]
}> = ({ publication, activePosts }) => {
    const { structuredData } = useLiveBlogPostingSchema(
        publication,
        activePosts,
    )

    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(structuredData)}
            </script>
        </Helmet>
    )
}
